import { useGetGeoPosition } from 'entities/users';
import { useCallback } from 'react';
import { useOperations as useUserOperations } from 'store/features/user';

export const useHandler = () => {
  const { resetUserGeoPosition } = useUserOperations();
  const updateGeoPositionUser = useGetGeoPosition();
  return useCallback(
    (isChecked: boolean) => {
      if (!isChecked) {
        resetUserGeoPosition();
        return;
      }

      updateGeoPositionUser();
    },
    [resetUserGeoPosition, updateGeoPositionUser]
  );
};
